import {
  take,
  fork,
  call,
  put,
  select,
} from 'redux-saga/effects';

import { apiGet } from './callApi';

import actionTypes from '../actionTypes';
import { getToken } from '../selectors';
import { failRaces, successRaces } from '../actionCreators/races';

import apiRoutes from '../../constants/apiRoutes';

function* getRaces(): any {
  try {
    const headers = {};
    const token = yield select(getToken);
    headers['x-access-token'] = JSON.stringify(token);

    const response = yield call(apiGet, 'REACT_APP_GAMEBOX_URL', apiRoutes.GET_RACES, { token }, headers);

    if (response.data.success) {
      yield put(successRaces(response.data?.result?.races));
    } else {
      yield put(failRaces(response?.data?.message));
    }
  } catch (e) {
    yield put(failRaces(e));
  }
}

export default function* watchRacesRequest() {
  while (true) {
    yield take([actionTypes.RACES_REQUEST, actionTypes.JOIN_TO_RACE_SUCCESS]);
    yield fork(getRaces);
  }
}
